module.exports = __webpack_public_path__ + "static/media/SAGovLogo.7a61957b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAGovLogo.png
// module id = 461
// module chunks = 0